import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// material

// ----------------------------------------------------------------------

export default function GlobalHeaader() {
    const { t, i18n } = useTranslation('translation')
    const navigate = useNavigate()

    let currentUrl = window.location.href;
  
    const setLanguageEnglish = () => {
      i18n.changeLanguage("en")
      navigate('/en/home')
    };
  
    const setLanguageFrench = () => {
      i18n.changeLanguage("fr")
      navigate('/fr/home')
    };  

  return (
    <div id="wb-bnr" className="container">
        <div className="row">
        <section id="wb-lng" className="col-xs-3 col-sm-12 pull-right text-right">
            <h2 className="wb-inv">Language selection</h2>
            <ul className="list-inline mrgn-bttm-0">
            <li>
                <a hrefLang="fr" lang="fr" href={i18n.language === 'en' ? currentUrl.replace('/en/', '/fr/') : currentUrl.replace('/fr/', '/en/')}>
                 {i18n.language === 'en' ? <span className="hidden-xs">Français</span> : <span className="hidden-xs">English</span>}
                 {i18n.language === 'en' ? <abbr title="Français" className="visible-xs h3 mrgn-tp-sm mrgn-bttm-0 text-uppercase">fr</abbr> : <abbr title="Français" className="visible-xs h3 mrgn-tp-sm mrgn-bttm-0 text-uppercase">en</abbr>}
                
                </a>
            </li>
            </ul>
        </section>
        <div className="brand col-xs-9 col-sm-5 col-md-4" property="publisher" typeof="GovernmentOrganization">
            <a href="https://www.canada.ca/en.html" property="url">
            <img src="https://www.canada.ca/etc/designs/canada/cdts/gcweb/v4_0_43/wet-boew/assets/sig-blk-en.svg" alt="Government of Canada" property="logo"/>
            <span className="wb-inv"> / <span lang="fr">Gouvernement du Canada</span>
            </span>
            </a>
            <meta property="name" content="Government of Canada"/>
            <meta property="areaServed" typeof="Country" content="Canada"/>
            <link id="StdIssueWasHere1" property="logo" href="https://www.canada.ca/etc/designs/canada/cdts/gcweb/v4_0_43/wet-boew/assets/wmms-blk.svg"/>
        </div>
        <section id="wb-srch" className="col-lg-offset-4 col-md-offset-4 col-sm-offset-2 col-xs-12 col-sm-5 col-md-4">
            <h2>Search</h2>
            <form action="https://www.canada.ca/en/sr.html" method="get" name="cse-search-box" role="search">
            <div className="form-group wb-srch-qry">
                <label htmlFor="wb-srch-q" className="wb-inv">Search Canada.ca</label>
                <input name="cdn" value="canada" type="hidden"/>
                <input name="st" value="s" type="hidden"/>
                <input name="num" value="10" type="hidden"/>
                <input name="langs" value="en" type="hidden"/>
                <input name="st1rt" value="1" type="hidden"/>
                <input name="s5bm3ts21rch" value="x" type="hidden"/>
                <input id="wb-srch-q" list="wb-srch-q-ac" className="wb-srch-q form-control" name="q" type="search" size="34" maxLength="170" placeholder="Search Canada.ca"/>
                <input type="hidden" name="_charset_" value="UTF-8"/>
                <datalist id="wb-srch-q-ac"></datalist>
            </div>
            <div className="form-group submit">
                <button type="submit" id="wb-srch-sub" className="btn btn-primary btn-small" name="wb-srch-sub">
                <span className="glyphicon-search glyphicon"></span>
                <span className="wb-inv">Search</span>
                </button>
            </div>
            </form>
        </section>
        </div>
    </div>
  );
}
